import AbstractSpeciality from '../components/abstract-speciality/abstract-speciality'
import ActiveAgenda from '../components/active-agenda/active-agenda'
import AgendasStatistics from '../components/agendas-statistics/agenda-statistics'
// import Identification from '../components/identification/identification'
// import NextPatient from '../components/next-patient/next-patient'
// import SelectDates from '../components/select-dates/dates'
import StatisticsAgendas from '../components/statistics/statistics'
import SummaryAgenda from '../components/summary-agenda/summary-agenda'
import SummaryBilling from '../components/summary-billing/summary-billing'
import SchedulingsOffline from '../components/schedulings/schedulings'

export default {
  ActiveAgenda,
  AgendasStatistics,
  AbstractSpeciality,
  // Identification,
  // NextPatient,
  // SelectDates,
  StatisticsAgendas,
  SummaryAgenda,
  SummaryBilling,
  SchedulingsOffline
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/resources/components.js